exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#socialShareModal .btn-share{font-size:22px;height:48px;width:48px;text-align:center;border-radius:50%;padding:0}#socialShareModal .custom-image{height:188px;-o-object-fit:contain;object-fit:contain;border-radius:9px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4d40b8c6","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/views/rd/assets/js/v2/components/socialShare.vue
// module id = Wt25
// module chunks = 1 6 8 12 13 14 15 25 27 29 34 36 37 38 40 41 43 45 47 55 58 63